import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@playbookux/playbook-web-core';

import {
  QuestionLabel,
  Container,
  ImageLabel,
  NotLoadedImage,
} from './styles';
import { FirstClickImage } from './components/first-click-image';

const FirstClickTestType = (props) => {
  const [showImage, setShowImage] = useState(false);
  const {
    label, imageUrl, onChange, onGoToNextPage,
  } = props;

  return (
    <Container>
      <QuestionLabel>{label}</QuestionLabel>

      {!showImage && (
        <>
          <ImageLabel>Click &quot;View Image&quot; to get started</ImageLabel>
          <Button onClick={() => setShowImage(true)}>View Image</Button>
        </>
      )}

      {imageUrl && showImage && (
        <FirstClickImage imageUrl={imageUrl} onChange={onChange} onGoToNextPage={onGoToNextPage} />
      )}
      {!showImage && (
        <NotLoadedImage />
      )}
    </Container>
  );
};

FirstClickTestType.propTypes = {
  label: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onGoToNextPage: PropTypes.func,
};

FirstClickTestType.defaultProps = {
  imageUrl: null,
  onGoToNextPage: () => {},
};

export default FirstClickTestType;
